import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { theme, getSpacing } from '@/styles/theme';

export const StyledHeaderContainer = styled(Box)({
  width: '100%',
  height: '100%',
  paddingTop: getSpacing.xl,
  paddingLeft: getSpacing.xxl,
  paddingRight: getSpacing.xl,
  backgroundColor: theme.palette.searchFilter.filterOptionBackground,
  borderRadius: 16,
  justifyContent: 'space-between',
  alignItems: 'center',
  display: 'inline-flex',
});

export const StyledContentContainer = styled(Box)({
  flex: '1 1 0',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: getSpacing.sm,
  display: 'inline-flex',
});

export const StyledTopRowContainer = styled(Box)({
  alignSelf: 'stretch',
  justifyContent: 'space-between',
  alignItems: 'center',
  display: 'inline-flex',
});

export const StyledLeftSideContainer = styled(Box)({
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: getSpacing.lg,
  display: 'flex',
});

export const StyledApiTitle = styled(Typography)({
  color: theme.palette.text.primary,
  variant: 'h1',
});

export const StyledTagsContainer = styled(Box)({
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: getSpacing.xs,
  display: 'flex',
});

export const StyledTabsContainer = styled(Box)({
  justifyContent: 'flex-start',
  alignItems: 'center',
  display: 'inline-flex',
});

export const StyledTabItem = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>(({ theme, isActive }) => ({
  paddingTop: getSpacing.md,
  paddingBottom: getSpacing.lg,
  paddingLeft: getSpacing.xl,
  paddingRight: getSpacing.xl,
  borderBottom: isActive ? `2px ${theme.palette.ui.borderFocus} solid` : '2px solid transparent',
  justifyContent: 'center',
  alignItems: 'center',
  gap: getSpacing.sm,
  display: 'flex',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.component.hoverOverlay,
  },
}));

export const StyledTabLabel = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>(({ theme, isActive }) => ({
  fontWeight: isActive ? theme.customFontWeights.semibold : theme.customFontWeights.regular,
  color: isActive ? theme.palette.text.primary : theme.palette.text.secondary,
}));
